export default "__VITE_ASSET__9633abfd__"